module.exports = __webpack_public_path__ + "static/media/car_text.db01dc71.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/car_text.png
// module id = 106
// module chunks = 0